import { FlexSpacer } from 'ui/flexSpacer/FlexSpacer';
import { Container } from 'ui/container/Container';
import { RelativeTime } from 'ui/utility/relativeTime';
import { ContentRestoreButton } from '../ContentRestoreButton';
import { StyledDL } from '../ContentPreview.styled';
import {
  MessagePreview,
  MessageContainer,
  MessageTitle,
  MessageContent,
  MessageMedia,
} from './ContentPreviewWebPush.styled';
import type { TemplateDiffContentPreviewProps, TemplateDiffContentWebPush } from '../../../types';

type ContentPreviewWebPushProps = TemplateDiffContentWebPush & TemplateDiffContentPreviewProps;

export const ContentPreviewWebPush = ({
  onClick,
  templateId,
  ...content
}: ContentPreviewWebPushProps) => {
  return (
    <Container size="medium" variant="primary" shadow="small">
      <FlexSpacer flexDirection="column" alignItems="stretch" gap="actionGap">
        <FlexSpacer justifyContent="space-between" alignItems="baseline">
          <StyledDL>
            <dt>Created</dt>
            <dd>
              <RelativeTime timestamp={content.createdAt} />
            </dd>
            <dt>Created by</dt>
            <dd>{content.creatorUserId}</dd>
          </StyledDL>
          <ContentRestoreButton contentId={content.id} onClick={() => onClick(content)} />
        </FlexSpacer>
        <Container size="small" hasBorder variant="secondary">
          <MessagePreview data-test="table-diff-web-push-message">
            <MessageContainer>
              <MessageTitle>{content.title}</MessageTitle>
              <MessageContent>{content.body}</MessageContent>
              {content.icon && (
                <MessageMedia
                  data-test="table-diff-web-push-message-icon"
                  style={{
                    backgroundImage: `url(${content.icon})`,
                  }}
                />
              )}
            </MessageContainer>
          </MessagePreview>
        </Container>
      </FlexSpacer>
    </Container>
  );
};
